import React from "react"
import { Link } from "gatsby"
import styled from "@emotion/styled"
import ButtonLink from "./ButtonLink"

const Outer = styled.div`
  display: grid;
  grid-template-columns:
    minmax(32px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(32px, auto);
  padding: 64px 0;
  align-items: center;
  background: ${props => props.theme.shade[20]};

  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 24px auto 24px;
  }
`
const Inner = styled.div`
  grid-column: 2;
  grid-row: 1;
  padding: 64px 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 64px;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`
const Column = styled.div`
  > * {
    color: #fff;
  }
`
const Desc = styled.h3`
  margin-top: 16px;
  margin-bottom: 8px;
  font-size: 1.2rem;
`
const FooterText = styled.div`
  grid-column: 1/-1;
  color: #fff;
  p {
    font-size: 0.8rem;
  }
`
const FooterNav = styled.div`
  display: grid;
  grid-auto-flow: row;
  gap: 12px;
  > * {
    color: #fff;
  }
`
const FooterLinks = styled.div`
  display: grid;
  grid-auto-flow: row;
  gap: 12px;
  > * {
    color: #fff;
  }
`
const Subheader = styled.h4`
  font-weight: 400;
  margin-bottom: 8px;
`
const ButtonContainer = styled.div`
  margin-top: 24px;
  display: flex;
`

export default function Footer() {
  return (
    <Outer>
      <Inner>
        <Column>
          <h2>Userfy (verb)</h2>
          <Desc>/ˈuserfʌɪ /</Desc>
          <p>
            To design an optimised digital experience using user insights and
            behavioural science.
          </p>
        </Column>
        <Column>
          <h2>Important Links</h2>
          <FooterNav>
            <Link to="/">Home</Link>
            <Link to="/our-user-testing/">Our user testing</Link>
            <Link to="/how-we-do-it/">How we do it</Link>
            <Link to="/about/">About</Link>
            <Link to="/additional-services/">Additional Services</Link>
            <Link to="/contact/">Contact</Link>
          </FooterNav>
        </Column>
        <Column>
          <h3>To discuss how our in-depth user testing could help you</h3>
          <FooterLinks>
            <Subheader>Contact Phil Randall (Founder)</Subheader>
            <a href="tel:07712669935">07712669935</a>
            <a href="mailto:phil.randall@userfy.co.uk">
              phil.randall@userfy.co.uk
            </a>
            <ButtonContainer>
              <ButtonLink
                to="/contact/"
                backgroundColorOverride={props => props.theme.primary}
              >
                Contact Us
              </ButtonLink>
            </ButtonContainer>
          </FooterLinks>
        </Column>
        <FooterText>
          <p>
            Userfy Ltd. Registered in England &amp; Wales 10354203 Orchard
            House, Nottingham, NG12 4AG
          </p>
        </FooterText>
      </Inner>
    </Outer>
  )
}
